<template>
	<div style="display: flex">
		<!--년간 실적 -->
		<sf-card width="500px" height="330px" :title="getMessage_('QWCC001489')" style="margin-top: -4px; margin-left: 19px">
			<template v-if="isLoading">
				<!--추가-->
				<bar-chart :height="280" ref="grpBar" :chartData="datacollection2" :options="optionCollection1" />
			</template>
		</sf-card>

		<!-- **년 월별 실적 -->
		<sf-card
			width="1400px"
			height="330px"
			:title="this.searchParams.searchDate + getMessage_('QWCC001451') + ' ' + getMessage_('QWCC001490')"
			style="margin-top: -4px; margin-left: 19px"
		>
			<template v-if="isLoading">
				<!--추가-->
				<line-chart :height="280" ref="grpLine" :chartData="datacollection1" :options="optionCollection2" />
			</template>
		</sf-card>
	</div>
</template>

<script>
import Chart from '@/qmsUtils/chartModule';
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/clma/PcIdxNum3M/store/helpers';
export default {
	components: {
		BarChart: Chart.BarChart,
		LineChart: Chart.LineChart
	},
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		datacollection1() {
			return {
				labels: this.LineChartLabel_, //x축 데이터( 년월)
				datasets: this.lineDataSet_
			};
		},
		datacollection2() {
			return {
				labels: this.stackedLabel_,
				datasets: this.stackedDataSet_
			};
		},
		optionCollection1() {
			//추가
			return {
				//BarChart
				responsive: true,
				maintainAspectRatio: false, // chart 높이 지정을 위해 필요
				plugins: {
					datalabels: {
						color: '#000', //데이터 값 표시 폰트 색상
						anchor: 'end'
					}
				},
				legend: {
					display: false,
					position: 'bottom' //범례 위치: 아래
				},
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: true,
								suggestedMin: 50,
								suggestedMax: this.chartBcYMaxVal_
							}
						}
					]
				}
			};
		},
		optionCollection2() {
			//추가
			return {
				//Linechart
				responsive: true,
				maintainAspectRatio: false, // chart 높이 지정을 위해 필요
				plugins: {
					datalabels: {
						color: '#000', //데이터 값 표시 폰트 색상
						anchor: 'end'
					}
				},
				legend: {
					display: true,
					position: 'bottom' //범례 위치: 아래
				},
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: true,
								suggestedMin: 50,
								suggestedMax: this.chartlcYMaxVal_
							}
						}
					],
					xAxes: [
						{
							offset: true, //x축 앞에 공간 두는 설정
							gridLines: {
								display: false //x축 관련 실선 안보이게 처리
							}
						}
					]
				}
			};
		}
	},
	methods: {
		...serviceMethods
	}
};
</script>

<style></style>
